import { rfqQuoteDetailsHeaderStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsHeader";
import { rfqQuoteDetailsInformationStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsInformation";
import { rfqQuoteDetailsQuoteLineCalculatorStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculator";
import { rfqQuoteDetailsSalesRepProductListStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsSalesRepProductList";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";


rfqQuoteDetailsInformationStyles.expirationDateGridItem= {
    width: 12,
    css: css`
        flex-direction: column;
        margin-top: 10px !important;
    `,
}

rfqQuoteDetailsHeaderStyles.narrowOverflowMenu= {
    cssOverrides: {
        wrapper: css`
            margin-left: 20px;
            button {
                min-width: 100%;
                &:hover {
                    border: none !important;
                    background: none !important;
                }
                &:focus {
                    outline: none !important;
                }
            }
        `,
    },
}

rfqQuoteDetailsHeaderStyles.deleteQuoteButton= {
    mergeCss:true,
    css: css`
        margin-left: 10px;
    `,
}

rfqQuoteDetailsHeaderStyles.submitQuoteButton= {
    mergeCss:true,
    css: css`
        margin-left: 10px;
    `,
}

rfqQuoteDetailsHeaderStyles.declineQuoteButton= {
    mergeCss:true,
    css: css`
        margin-left: 10px;
    `,
}

rfqQuoteDetailsHeaderStyles.acceptQuoteButton= {
    mergeCss:true,
    css: css`
        margin-left: 10px;
    `,
}

rfqQuoteDetailsSalesRepProductListStyles.quoteLineButton= {
    mergeCss:true,
    css: css`
        ${({ theme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        width: 100%;
                    `,
                ],
                "max",
            )}
    `,
}

rfqQuoteDetailsQuoteLineCalculatorStyles.cancelButton= {
        mergeCss:true,
        variant: "secondary",
        css: css`
            margin-right: 10px;
        `,
}

rfqQuoteDetailsQuoteLineCalculatorStyles.resetButton= {
    mergeCss:true,
    variant: "secondary",
    css: css`
        margin-right: 10px;
    `,
}
